'use client';

import { Button } from '@up2stay/up2promo-ui';

import { FEEDBACK_MAIL_VARIABLES } from '@/core/lib/feedback-mail-preview';

export type FeedbackVariableLabels = Record<
  (typeof FEEDBACK_MAIL_VARIABLES)[number]['key'],
  string
>;

type FeedbackVariableInserterProps = {
  labels: FeedbackVariableLabels;
  onInsert: (token: string) => void;
  hint?: string;
};

/** Plain-language chips to insert merge fields into email copy. */
export function FeedbackVariableInserter({
  labels,
  onInsert,
  hint,
}: FeedbackVariableInserterProps) {
  return (
    <div className="space-y-2">
      {hint ? <p className="text-xs text-muted-foreground">{hint}</p> : null}
      <div className="flex flex-wrap gap-1.5">
        {FEEDBACK_MAIL_VARIABLES.map((variable) => (
          <Button
            key={variable.key}
            type="button"
            variant="outline"
            size="sm"
            className="h-8 rounded-md px-2.5 text-xs font-medium"
            onClick={() => onInsert(variable.insert)}
          >
            {labels[variable.key]}
          </Button>
        ))}
      </div>
    </div>
  );
}
